<script>
import BasePage from "../my-components/base-page";
import util from '@/libs/util';
export default {
  name: "page-active-log",
  components: {BasePage},
  data() {
    return {
      table: {
        loading: false,
        data: [],
        page: {
          type:-1,
          current: 1,
          size: 10,
          total: 0,
          sortKey: 'id',
          sortMethod: 'desc',
          keyword:''
        }
      },
    };
  },
  computed: {
    getColumns() {
      return [
        {
          title: this.$t("l.active_code"),
          align: 'center',
          key:"integratedGivenCode",
        },
        {
          title: this.$t("l.latitude"),
          align: 'center',
          key:"latitude",
        },
        {
          title: this.$t("l.longitude"),
          align: 'center',
          key:"longitude",
        },
        {
          title: this.$t("l.create_time"),
          align: 'center',
          key:"create_time",
        },
        {
          title: this.$t("l.operate_user"),
          align: 'center',
          key:"create_user_name",
        },
      ]
    }
  },
  methods: {
    loadData() {
      this.table.loading = true;
      util.ajax.get('/dtzj/active/logs',{params:this.table.page}).then((res) => {
        this.table.loading = false;
        this.setPage(res.data);
      });
    },
    setPage(data){
      if(data ){
        this.table.data = data.list;
        this.table.page.total = data.totalRow;
      }
    },
  },
  created() {
    this.loadData();

  },
}
</script>

<template>
  <BasePage :title="$t('l.data_manage')" icon="md-archive">
    <Row type="flex" justify="end" class="margin-t-b-10">
      <Col  class="margin-left-5">
        <Input v-model="table.page.keyword" :placeholder="$t('l.remark67')" style="width: 300px" />
      </Col>
      <Col  class="margin-left-5">
        <Button type="primary"  @click="loadData(1)">{{$t('l.search')}} </Button>
      </Col>
<!--      <Col  class="margin-left-5">-->
<!--        <Button type="error"  @click="deleteData">{{$t('l.delete')}} </Button>-->
<!--      </Col>-->
    </Row>
    <Row class="full">
      <Table ref="selection" stripe border :columns="getColumns" :data="table.data" :loading="table.loading"></Table>
      <Row type="flex" justify="center">
        <Col>
          <Page size="small"
                :current="table.page.current"
                :page-size="table.page.size"
                :total="table.page.total"
                show-elevator show-sizer
                show-total
                @on-page-size-change="($event)=>{table.page.size = $event,loadData(1)}"
                @on-change="($event)=>{table.page.current = $event,loadData()}"></Page>
        </Col>
      </Row>
    </Row>
  </BasePage>
</template>

<style scoped lang="less">

</style>